import React from "react";
import { Row, Col, Modal, Button, Input } from "antd";
import styles from "../DashBoard.module.scss";

type Props = {
  visible: boolean;
  setVisibility: Function;
  updatedFavName: string;
  setUpdateFavName: Function;
  handleSaveRenamedFav: () => void;
};

function RenameFavoriteModal({
  visible,
  setVisibility,
  updatedFavName,
  setUpdateFavName,
  handleSaveRenamedFav,
}: Props) {
  function handleRenameModalClose() {
    setVisibility(false);
  }

  function handleFavoriteNameChange(value: string) {
    let name = value.replace(/[^a-z0-9\s]/gi, "");
    const newValue = name.replace(/\s\s+/g, " ");
    newValue.trimStart() === newValue && setUpdateFavName(newValue);
  }

  return (
    <Modal
      visible={visible}
      centered
      width="unset"
      className={styles.modalFavContainer}
      footer={
        <Row justify="center" gutter={[10, 0]} className={styles.modalBtns}>
          <Col>
            <Button
              className={styles.modalCloseBtn}
              onClick={handleRenameModalClose}
            >
              Cancel
            </Button>
          </Col>
          <Col>
            <Button
              disabled={updatedFavName.trimEnd().length <= 3}
              className={
                updatedFavName.trimEnd().length >= 3
                  ? "wandaBtnEnabled " + styles.modalYesBtn
                  : "wandaBtnDisabled " + styles.modalYesBtn
              }
              onClick={handleSaveRenamedFav}
            >
              Save Favorite
            </Button>
          </Col>
        </Row>
      }
    >
      <Row justify="center">
        <Col className={styles.modalHeading}>Rename Favorite</Col>
      </Row>
      <Row justify="center" className={styles.modalContent}>
        <Col>Enter a name for your favorite:</Col>
      </Row>
      <Row justify="center" className={styles.modalContent}>
        <Col>
          <Input
            onChange={(e) => handleFavoriteNameChange(e.target.value)}
            placeholder="Example: John's doctor"
            className={styles.modalFavInbox}
            value={updatedFavName}
            maxLength={35}
          />
        </Col>
      </Row>
    </Modal>
  );
}

export default RenameFavoriteModal;
